import { useTranslation } from 'react-i18next';
import { SourceTypeE } from 'shared/api/types/common';
import { OneUserResourceT } from 'shared/api/types/user-resources';
import ModelInfo, { InfoBoxesT } from 'shared/components/ModelInfo';
import { LayoutsE, PathsE } from 'shared/routes';

interface Props {
  data: OneUserResourceT['response'];
}

const UserResourceInfo = ({ data }: Props) => {
  const { t } = useTranslation();
  const infoBoxes: InfoBoxesT = [
    {
      label: t('links.table.resource'),
      type: 'link',
      linkLabel: data.resource.name,
      link: data.resource.type === SourceTypeE.BOT_ENTITY
        ? `/${LayoutsE.DASHBOARD}/${PathsE.BOTS}/${data.resource.id}`
        : `/${LayoutsE.DASHBOARD}/${PathsE.CHANNELS}/${data.resource.id}`
    },
    {
      label: t('links.table.type'),
      type: 'text',
      value: data.resource.type,
    },
    {
      label: t('users.user'),
      type: 'link',
      linkLabel: data.user.name,
      link: `/${LayoutsE.DASHBOARD}/${PathsE.USERS}/${data.user.id}`,
    },
  ]

  return (
    <ModelInfo infoBoxes={infoBoxes} />
  );
};

export default UserResourceInfo;
